import DisplayPoster from "./DisplayPoster";

export default DisplayPoster;